
//正则
let _regular = {

    /*是否带有小数*/
    is_decimal : function (str) {
        let objRegExp= /^\d+\.\d+$/;
        return objRegExp.test(str);
    },

    /*校验是否中文名称组成 */
    is_china : function (str) {
        let reg = /^[\u4E00-\u9FA5]{2,4}$/;   /*定义验证表达式*/
        return reg.test(str);     /*进行验证*/
    },

    /*校验是否全由8位数字组成 */
    is_eight_num : function (str) {
        let reg = /^[0-9]{8}$/;   /*定义验证表达式*/
        return reg.test(str);     /*进行验证*/
    },

    /*校验电话码格式 */
    is_mobile : function (str) {
        // let reg = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
        let reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;
        return reg.test(str);
    },

    /*校验邮件地址是否合法 */
    is_email : function (str) {
        let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
        return reg.test(str);
    },

    is_datetime : function(date){
        let reg = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/;
        return date.match(reg);
    },

    /*是否包含 */
    is_contain : function (content, str) {
        let reg = new RegExp(str);   /*定义验证表达式*/
        return reg.test(content);     /*进行验证*/
    },

};

//导出
export default _regular;
